import axios from 'axios';

export async function tcGenerator(productCode) {
    const sessionToken = localStorage.getItem("sessionToken");
    const client = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        timeout: 30000,
        headers: { 
            "Content-Type": "application/json",
            "authorization": 'bearer ' + sessionToken
        }
    });

    try {
        const response = await client.post('get-terms-pdf', { productCode, websiteUrl: window.location.href });
        const data = response.data;

        if (data.HasErrors || !data.FileContent) {
            return {
                hasErrors: true,
                errorMessage: data.Errors && data.Errors.length > 0 ? data.Errors[0] : "Unknown Error"
            };
        }

        return { 
            fileContent: data.FileContent, 
            hasErrors: false 
        };
    } catch (err) {
        return { 
            hasErrors: true,
            errorMessage: "Unknown Error"
        };

    }
}